import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('webhoooks init')
}

export async function list(app, apiHost, pageNo = 1, searchText = '') {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks`
  return axios
    .post(`${URL}`, post, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}`
  return axios
    .get(`${URL}`, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}`
  return axios
    .delete(`${URL}`, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getTriggersByID(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}/triggers`
  return axios
    .get(`${URL}`, {
      headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function addTriggers(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}/triggers`
  return axios
    .post(
      `${URL}`,
      {
        triggerIds: post,
      },
      {
        headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function delTriggers(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/webhooks/${id}/triggers`
  return axios
    .delete(
      `${URL}`,

      {
        headers: { ...getChatApiHeaders(app), 'X-Legacy-Webhook': true },
        data: {
          triggerIds: post,
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
